import styled from "@emotion/styled";

export default styled.figure`
  display: block;
  overflow: hidden;
  max-width: 100vw;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;

  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    vertical-align: middle;
    margin-top: -1px;
  }
`;
